import { configureStore, getDefaultMiddleware } from "@reduxjs/toolkit";
import FaqSlice from "./FaqSlice";

export const store = configureStore({
  reducer: {
        Faq :FaqSlice,
  },
  middleware: getDefaultMiddleware({
    serializableCheck: false,
  }),
});
